import { Pipe } from '@angular/core';

@Pipe({ name: 'booleanToFrench' })
export class BooleanToFrenchPipe {
  transform(value: boolean): string {
    if (typeof value === 'boolean') {
      return value === true ? 'Oui' : 'Non';
    }
    return value;
  }
}
